export const EXPORT_TEMPLATE_LOAD = 'EXPORT_TEMPLATE_LOAD'
export const EXPORT_TEMPLATE_LOAD_PENDING = 'EXPORT_TEMPLATE_LOAD_PENDING'
export const EXPORT_TEMPLATE_LOAD_FULFILLED = 'EXPORT_TEMPLATE_LOAD_FULFILLED'
export const EXPORT_TEMPLATE_LOAD_REJECTED = 'EXPORT_TEMPLATE_LOAD_REJECTED'

export const CLEAR_EXPORT_TEMPLATE = 'CLEAR_EXPORT_TEMPLATE'
